import React, { Component } from 'react';
import { connect } from 'react-redux';
import TableList from 'components/TableList';
import Form from '../../components/react-validation/components/form';
import Submit from '../../components/react-validation/components/submit';
import Input from '../../components/react-validation/components/input';
import Textarea from '../../components/react-validation/components/text-area';
import * as Vali from '../../helper/validator-helper';
import {AppSettings} from '../../constants';
import PropTypes from 'prop-types';
import { MessengerBox } from '../../components/messenger-box/messenger-box';
import { ContextMenu } from '../../components/context-menu/context-menu';
import PubSub from '../../services/pubsub-service';
import * as PubSubActionType from '../../services/constants';
import * as ModelActionType from '../constants';
// import * as ProjectActionType from '../../Projects/constants';
import { EditModel } from './edit-model';
import { RoomModel } from './room-model';
import '../model.css';
import Translate from 'components/translate';

const defaultParams = {
  defaultSortName: 'name',
  defaultSortOrder: 'ascending',
  sizePerPage: 10
};

class AddModel extends Component {

  static propTypes = {
    match: PropTypes.object,
    ModelProfile: PropTypes.object,
    ManageRoomsModels: PropTypes.object,
    IsOpenFormEdit: PropTypes.bool,
    ManageModels: PropTypes.object,
    IsOpenPopUpRoomModel: PropTypes.bool,
    AddRoomToModelErrorMsg: PropTypes.any,
    ErrorMsg: PropTypes.array,
    SelectListRooms: PropTypes.array,
    history: PropTypes.object,
    dispatch: PropTypes.func,
    projectId: PropTypes.string
  }

  constructor(props) {
    super(props);

    this.state = {
      defaultSortName: props.ManageModels.params.sort.field, // default sort column name
      defaultSortOrder: props.ManageModels.params.sort.order, // default sort order,
      currentPage: props.ManageModels.params.skip,
      sizePerPage: props.ManageModels.params.take,
      totalRecord: props.ManageModels.params.totalRecord,
      projectName: '',
      isOpenModalEditPlan: false
    };

    this.projectId = this.props.match.params.projectId ? this.props.match.params.projectId : this.props.projectId;

    this.isNew = this.props.match.params.isNew === 'true';

    var me = this;

    PubSub.subscribe(PubSubActionType.PUBLISH_PROJECT_INFORMATION, (msg, data) => {
      me.setState({ projectName: data.project.name });
    });
  }

  componentDidMount() {
    this.binding(this.objToParams(this.props.ManageModels.params));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ErrorMsg.length > 0 && !nextProps.IsOpenFormEdit) {
      this.form.showError(this.refs['name'], nextProps.ErrorMsg[0].error);
    } else {
      this.form.resetForm(this.refs);
    }

    if (nextProps.ManageModels) {
      this.setState({
        totalRecord: nextProps.ManageModels.params.totalRecord,
        currentPage: nextProps.ManageModels.params.skip
      });
    }

  }

  componentWillUnmount() {
    this.props.dispatch({
      type: ModelActionType.RESET_MODEL,
      params: null
    });

    // this.props.dispatch({
    //   type: ProjectActionType.RESET_PROJECT,
    //   params: null
    // });
  }

  customRenderBtnAction(item) {
    return <a className='glyphicon glyphicon-option-vertical cls-table-black-icon' onClick={(e) => { this.onContextMenu(e, item); }} />;
  }

  customRenderLots(item) {
    return <span>{item.countLots}</span>;
  }

  binding(params) {

    this.props.dispatch({
      type: ModelActionType.SEARCH_MODEL_ASYNC,
      params: params
    });
  }

  objToParams(obj) {
    return {
      searchKey: '',
      projectId: this.projectId,
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      skip: obj.skip - 1,
      take: obj.take
    };
  }

  onContextMenu(e, item) {

    var contextItem = [{
      title: 'Locations',
      icon: 'glyphicon glyphicon-share-alt',
      event: this.onOpenRoomModel.bind(this)
    }, {
      title: 'Edit plan',
      icon: 'glyphicon glyphicon-pencil',
      event: this.onOpenEditModel.bind(this)
    }];

    this.cxtMenu.state.event(e, item, contextItem);
  }

  onOpenRoomModel(e, item) {
    this.setState({isOpenPopUpRoomModel: true});
    this.roomModel.onBindRoomModel(this.props, item.id, item.name);
  }
  onCloseRoomModal = () => {
    this.setState({isOpenPopUpRoomModel: false});
  }

  onOpenEditModel(e, item) {
    this.props.dispatch({
      type: ModelActionType.GET_MODEL_BY_ID_ASYNC,
      params: item.id,
      callback: () => {
        this.setState({ isOpenModalEditPlan: true });
      }
    });
  }

  onCloseEditPlanModal = () => {
    this.setState({ isOpenModalEditPlan: false });
  }

  refreshList(params) {
    this.setState({
      defaultSortName: params.defaultSortName,
      defaultSortOrder: params.defaultSortOrder,
      sizePerPage: params.sizePerPage
    }, () => {
      this.props.dispatch({
        type: ModelActionType.SEARCH_MODEL_ASYNC,
        params: {
          searchKey: '',
          projectId: this.projectId,
          sortField: params.defaultSortName,
          sortOrder: params.defaultSortOrder,
          skip: params.currentPage - 1,
          take: params.sizePerPage
        }
      });
    }
    );
  }

  onSave(e, data, modelActionType, isEdit) {
    this.props.dispatch({
      type: modelActionType,
      params: {
        data: data,
        search: this.objToParams(this.props.ManageModels.params),
        isEdit: isEdit
      },
      callback: () => {
        this.onCloseEditPlanModal();
      }
    });
  }

  onSubmit(e) {
    e.preventDefault();
    this.onSave(e, this.form.getValues(), ModelActionType.CREATE_MODEL_ASYNC, false);
  }

  renderTableModels() {
    const column = [
      { field: 'id', header: 'id', hidden: true, isKey: true, sort: false, dataAlign: 'left', headerAlign: 'left' },
      { field: 'name', header: 'Plan name', hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left' },
      { field: 'code', header: 'Plan code', hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left' },
      { field: '', header: '', hidden: false, isKey: false, sort: true, dataAlign: 'right', headerAlign: 'right',
        customRender: this.customRenderBtnAction.bind(this), className: 'column-action', columnClassName: 'column-action' }
    ];

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: this.state.totalRecord,
      hideSizePerPage: true
    };

    return <div>
      <TableList
        column={column}
        defaultParams={defaultParams}
        data={this.props.ManageModels.items}
        options={options}
        refreshPageList={this.refreshList.bind(this)}
        refreshList={this.refreshList.bind(this)}
      />
    </div>;
  }

  render() {
    return <div>
      <div className='alert alert-info' style={{ 'margin': '0 auto', 'maxWidth': '640px' }}><strong>Important note:</strong> If you are about to import <Translate translateKey='lot' plurals /> using spreadsheet, you can ignore adding plans since all data (<Translate translateKey='phase' plurals />, plans) will be imported along with lots.</div>
      <br />
      <div className='block' style={{ 'margin': '0 auto', 'maxWidth': '640px' }}>
        <br />
        <div className='tab-content'>
          <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit.bind(this)}>
            <Input type='hidden' name='projectId' ref='projectId' value={this.projectId} />
            <div className='form-group'>
              <label>Plan name <span className='text-danger'>*</span></label>
              <Input type='text'
                name='name'
                ref='name'
                placeholder='Plan name'
                className='form-control'
                max='200'
                maxlength='200'
                validations={[Vali.required, Vali.maxlength]} />
            </div>
            <div className='form-group'>
              <label>Plan code</label>
              <Input type='text'
                name='code'
                ref='code'
                placeholder='Plan code'
                className='form-control'
                max='200'
                maxlength='200'
                validations={[Vali.maxlength]} />
            </div>
            <div className='form-group'>
              <label>Note</label>
              <Textarea
                name='note'
                ref='note'
                placeholder='Note'
                className='form-control'
                max='200'
                maxlength='200'
                validations={[Vali.maxlength]} />
            </div>
            <div className='form-group center-buttons'>
              <Submit className='btn btn-primary btn-submit btn-siteone'>Add</Submit>
            </div>
          </Form>
          <div className='form-group'>
            <h5 style={{ 'marginBottom': '15px' }}>Plans ({this.state.totalRecord})</h5>
            {this.renderTableModels()}
            <ContextMenu ref={(ref) => { this.cxtMenu = ref; }} />
            <MessengerBox ref={(ref) => { this.msgBox = ref; }} title={AppSettings.COMPANY_NAME} />
          </div>
        </div>
      </div>

      <EditModel
        item={this.props.ModelProfile}
        errorMsg={this.props.ErrorMsg}
        isOpenFormEdit={this.state.isOpenModalEditPlan}
        onSubmit={this.onSave.bind(this)}
        onCloseModal={this.onCloseEditPlanModal} />

      <RoomModel ref={c => { this.roomModel = c; }}
        isOpenPopUpRoomModel={this.state.isOpenPopUpRoomModel}
        manageRoomsModels={this.props.ManageRoomsModels}
        errorMsg={this.props.AddRoomToModelErrorMsg}
        selectListRooms={this.props.SelectListRooms}
        parentProps={{...this.props}}
        onCloseRoomModal={this.onCloseRoomModal}
      />
    </div>;
  }
}

const mapStateToProps = (state) => {
  return state.ModelStore;
};

export default connect(mapStateToProps)(AddModel);



// WEBPACK FOOTER //
// ./src/Model/Containers/add-model.js